// @ts-nocheck
/* eslint-disable */
export const niNavRightMobileIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 12"><path d="M0 5L5 0 5.7 0.7 1.4 5 5.7 9.3 5 10z" transform="translate(-286 -670) translate(286 670) matrix(-1 0 0 1 7 1)" fill="#044123" fill-rule="evenodd"/></svg>`,
    name: 'nav-right-mobile' as const
};